import type {
  FetchLanguageTermsDefaultAction,
  FetchLanguageTermsFulfilledAction,
  FetchLanguageTermsRejectedAction,
} from "domains/language/actionTypes";
import { LanguageDomainActionType } from "domains/language/actionTypes";

export const fetchTerms = (meta: FetchLanguageTermsDefaultAction["meta"]): FetchLanguageTermsDefaultAction => ({
  type: LanguageDomainActionType.FETCH,
  meta,
});

export const fetchTermsSuccess = (
  payload: FetchLanguageTermsFulfilledAction["payload"],
  meta: FetchLanguageTermsFulfilledAction["meta"],
): FetchLanguageTermsFulfilledAction => ({
  type: LanguageDomainActionType.FETCH_FULFILLED,
  payload,
  meta,
});

export const fetchTermsFailure = (): FetchLanguageTermsRejectedAction => ({
  type: LanguageDomainActionType.FETCH_REJECTED,
});
